import { render, staticRenderFns } from "./PhoneFrame.vue?vue&type=template&id=c7579b4a&scoped=true"
import script from "./PhoneFrame.vue?vue&type=script&lang=js"
export * from "./PhoneFrame.vue?vue&type=script&lang=js"
import style0 from "./PhoneFrame.vue?vue&type=style&index=0&id=c7579b4a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7579b4a",
  null
  
)

export default component.exports